// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".field_placeholder[data-v-626cb09a]{color:var(--el-text-color-placeholder);font-size:12px}.desc[data-v-626cb09a]{color:var(--el-text-color-secondary);display:inline-block;vertical-align:middle;margin-left:10px}", ""]);
// Exports
module.exports = exports;
